import api from "./axios";

export const MyMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/engage/my-matches/", {
    params,
  });
  return response.data.data;
};

export const RecentlyViewed = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/explore/recently-viewed/", {
    params,
  });
  return response.data.data;
};

export const CareerMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/explore/career-matches/", {
    params,
  });
  return response.data.data;
};

export const ProfessionalMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/explore/professional-matches/", {
    params,
  });
  return response.data.data;
};

export const ProfileMayLike = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/explore/profile-you-may-like/", {
    params,
  });
  return response.data.data;
};

export const NearMeMatches = async ({ queryKey }) => {
  const [_key, params] = queryKey;
  const response = await api.get("/users/explore/nearme-matches/", {
    params,
  });
  return response.data.data;
};
